import React, { Component } from "react";
import ReactDOM from "react-dom";
import Pane from "./Pane.jsx";
import CamSwitchBoard from "./CamSwitchBoard.jsx";
import Actuators from "./Actuators/Actuators.jsx";
import ActuatorPad from "./Actuators/ActuatorPad.jsx";
import ActivitiesWidget from "./Activity/ActivitiesWidget.jsx";
import {overrideConsole} from '../../console.js';
import api_fetch from "../../api.js";
import version_info from "../../version.js";



const MAX_PANES = 4;

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function setDifference(setA, setB) {
  let _difference = new Set(setA)
  for (let elem of setB) {
      _difference.delete(elem)
  }
  return _difference
}
function getPanesCams(panes){
  let cams = new Set();
  for(let pane of panes){
    cams.add(pane.camName);
  }
  return cams;
}

class App extends Component {
  constructor() {
    super();
    // this.panes_count = 2;
    this.camSwitchBoardContainer = React.createRef();
    this.setPanes = this.setPanes.bind(this);
    this.addCam = this.addCam.bind(this);
    this.removeCam = this.removeCam.bind(this);
    this.getCamPane = this.getCamPane.bind(this);
    this.removeAllCams = this.removeAllCams.bind(this);
    this.showCamSwitchBoard = this.showCamSwitchBoard.bind(this);
    this.hideCamSwitchBoard = this.hideCamSwitchBoard.bind(this);
    this.blurTimeMet = this.blurTimeMet.bind(this);
    this.shutDownTimeMet = this.shutDownTimeMet.bind(this);
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.onWindowBlur = this.onWindowBlur.bind(this);
    this.onPanesClick = this.onPanesClick.bind(this);
    this.setVideoStatus = this.setVideoStatus.bind(this);
    this.setActiveActuator = this.setActiveActuator.bind(this);
    this.closeActuatorPad = this.closeActuatorPad.bind(this);
    this.setHightLightPane = this.setHightLightPane.bind(this);
    this.setActivityWidgetArea = this.setActivityWidgetArea.bind(this);
    this.forceCamSwitchBoardScroll = undefined;
    
    this.state = {
        loading_state: "initial",
        server : {name: "?",blur_time_limit: null },
        cameras : [],
        user_actuators_names: [],
        actuators: [],
        actuator_groups: {},
        intercoms: {},
        microphones: [],
        panes : [],
        cams_to_reload: [],
        cams_to_remove: [],
        activity_widget_area: undefined,
        user_activity_areas: [],
        camSwitchBoardIsVisible: false,
        actuatorMenuIsVisible: false,
        activeActuator: null,
        debugging: _debugging,
        will_shut_down: false,
        video_status: {},
        area_cams: {}
    };

  }
  // setDebug() {
  //   this.setState({debugging:true})
  //   setTimeout(overrideConsole, 1000);
  // }

  getNewPaneId() {
    if(this.state.panes.length == MAX_PANES)
      return -1;

    // TODO: Other strategies for adding
    return this.state.panes.length
  }
  getCamPane(camName) {
    for (const pane of this.state.panes){
        if(pane.camName === camName ){
          return pane;
        }
    }
    return undefined;
  }
  setPanes(panes){
      let initialCams = getPanesCams(this.state.panes);
      let newCams = getPanesCams(panes);
      this.setState({panes});
      let removed = setDifference(initialCams, newCams);
      let added = setDifference(newCams, initialCams);
      // console.log("updating panes ", removed, added);
      if(removed.size > 0){
        // console.log("removed ", removed);
      }
      if(added.size > 0){
        // console.log("added ", added);
      }
      if(added.size > 0 || removed.size > 0){
        this.setActivityWidgetArea(removed, added, panes);
      }

  }
  removeAllCams() {
     this.setPanes([]);
  }
  removeUnPinnedCams() {
    const panes = this.state.panes.filter((value) => value.pinned);
    this.setPanes(panes);

  }
  isCamOnPanes(camName) {
    for(const pane of this.state.panes){
      if (pane.camName == camName)
        return true;
    }
    return false;
  }
  addCam(camName, pinned){
    if (this.isCamOnPanes(camName) === true && pinned === false){
      console.warn("cam already in panes", camName)
      return;
    }
    let panes = addCamToPanes([...this.state.panes], camName, pinned)
    if (panes != undefined){
      this.setPanes(panes);
    }
  }

  removeCam(camName, force){
    if (this.isCamOnPanes(camName) == false){
      console.warning("cam not in panes", camName)
      return;
    }
    let panes = removeCamFromPanes([...this.state.panes], camName, force);
    this.setPanes(panes);
  }
  setHightLightPane(camName, hightlight){
    const panes =this.state.panes.map((pane) =>{
       if (pane.camName !== camName){
         return pane
       }
       return {...pane, hightlight}
    });
    this.setPanes(panes);

  }
  showCamSwitchBoard(){
    if (this.state.activeActuator){
      return;
    }

    this.setState({camSwitchBoardIsVisible: true, actuatorMenuIsVisible: true});
  }
  hideCamSwitchBoard(){
    this.forceCamSwitchBoardScroll = this.camSwitchBoardContainer.current.scrollTop;
    this.setState({
      camSwitchBoardIsVisible: false,
      actuatorMenuIsVisible: false
    });
  }
  onPanesClick() {
    if (this.state.panes.length > 0){
      if (this.state.camSwitchBoardIsVisible === true)
        this.hideCamSwitchBoard();
      else
        this.showCamSwitchBoard();
    }
  }
  setVideoStatus(camName, status){
    // console.log("setting video status", camName, status)
    let video_status = this.state.video_status;
    video_status[camName] = status
    this.setState({video_status})

  }
  setActiveActuator(actuator){
    if (actuator == null){
      // removing actuator, need to bring-back the prev cams sate
      if(this.state.cams_to_reload || this.state.cams_to_remove){
        let panes = [...this.state.panes];
        for (const cam of this.state.cams_to_reload){
          panes = addCamToPanes(panes, cam, true);
        }
        for(const cam of this.state.cams_to_remove){
          panes = removeCamFromPanes(panes, cam, true);
        }
        this.setState(
          {
            cams_to_reload: [], 
            cams_to_remove: [], 
            activeActuator: null
          })
        this.setPanes(panes);
      }
      return;
    }
    // setting an actuator

    let state = {activeActuator:actuator};
    if (actuator.requires_cams){
      // need to save and changes cams state
      let panes = [...this.state.panes];
      let camsToRemove = [];
      let newRequiredCams = [...actuator.requires_cams];
      for(const pane of panes){
        if (newRequiredCams.includes(pane.camName)){
          newRequiredCams = newRequiredCams.filter((item) => item !=pane.camName)
        }
        else{
          camsToRemove.push(pane.camName)
          // this.removeCam(pane.camName, true);
        }
      }
      for (const cam of camsToRemove){
        panes = removeCamFromPanes(panes, cam, true);
      }
      for (const cam of newRequiredCams){
        panes = addCamToPanes(panes, cam, true);
      }
      state["cams_to_reload"] = [...camsToRemove];
      state["cams_to_remove"] = [...newRequiredCams];
      this.setPanes(panes);
    }
    else{
      state["cams_to_reload"] = []
      state["cams_to_remove"] = []
    }

    this.setState(state);
    this.hideCamSwitchBoard()

  }
  closeActuatorPad(){
    this.setActiveActuator(null);
    // this.showCamSwitchBoard();
    this.setState({camSwitchBoardIsVisible: true, actuatorMenuIsVisible: true});

  }

  componentDidMount(){
    if (this.state.debugging === true){
      overrideConsole();
    }
    window.addEventListener("focus", this.onWindowFocus);
    window.addEventListener("blur", this.onWindowBlur);
    this.fetchUser();
    this.fetchServer();


  }
  componentDidUpdate(){
    if( this.forceCamSwitchBoardScroll && this.state.camSwitchBoardIsVisible === true){
      if (this.camSwitchBoardContainer.current){
        this.camSwitchBoardContainer.current.scrollTop = this.forceCamSwitchBoardScroll;
        this.forceCamSwitchBoardScroll = undefined;
      }
    }
  }
  onWindowFocus(){
    // console.log("on focus within APP");
    clearTimeout(this.on_blur_timer);
    clearTimeout(this.shut_down_timer);
    this.setState({will_shut_down : false});

  }
  onWindowBlur(){
    // console.log("on blur within APP");
    if (this.state.server.blur_time_limit != null){
      if (this.state.panes.length > 0)
        this.on_blur_timer = setTimeout(this.blurTimeMet, this.state.server.blur_time_limit*1000);

    }

  }
  blurTimeMet() {
    // console.log("blur time met")
    // this.removeAllCams()
    this.setState({will_shut_down : true});
    this.shut_down_timer = setTimeout(this.shutDownTimeMet, 30000);

  }
  shutDownTimeMet(){
    this.removeAllCams()
    this.setState({will_shut_down : false});

  }
  setActivityWidgetArea(removedCams, addedCams, newPanes){
    
    let cams = getPanesCams(newPanes);
    let areas = new Set();
    for (const cam of cams){
      let cam_name_underscore = cam.replaceAll("-", "_");
      if(cam_name_underscore in this.state.area_cams){
        areas.add(this.state.area_cams[cam_name_underscore])
      }
    }
    if(areas.size > 1){
      // remove all
      areas = new Set();
    }
    let new_area = null;
    if (areas.size > 0){
      new_area = areas.values().next().value
    }
    if(this.state.activity_widget_area !== undefined){
      if(new_area && new_area != this.state.activity_widget_area){
        if (this.state.user_activity_areas.includes(new_area)){
          console.log("changing area", new_area)
          this.setState({activity_widget_area: new_area});
        }
      }
      if(new_area == null){
        console.log("removing area");
        this.setState({activity_widget_area: undefined})
      }
    }
    else{
      if(new_area){
        if (this.state.user_activity_areas.includes(new_area)){
          console.log("setting new area", new_area)
          this.setState({activity_widget_area: new_area})
        }

      }
    }
  }  

  fetchServer() {
    api_fetch("/api/server").then(response => {
      if (!response.ok){
        throw new Error(`${response.status}: ${response.statusText}`)
      }
      return response.json();

    }).then(server => {
      this.setState({server})
    })
    .catch(error => {
      console.error(error)
    })
  }
  fetchUser() {
    this.setState({loading_state: "getting-user", camSwitchBoardIsVisible: false, actuatorMenuIsVisible: false});
    api_fetch("/api/user").then(response => {
        if (!response.ok){
          throw new Error(`${response.status}: ${response.statusText}`)
        }
        return response.json();
      
    })
    .then(user => {
      if (!user.cams ){
        throw new Error(`No capabilities info [1] (${user.id}, ${user.name})` )
      }
      this.setState(
        {
          user: user, 
          cameras: user.cams.map(camName => camName.split(".").slice(0,-1).join(".") ), 
          loading_state: "ok", 
          camSwitchBoardIsVisible: true, 
          actuatorMenuIsVisible: true
        }
      );

      if (user.actuators){
        this.setState({user_actuators_names: user.actuators});
        for (let i=0; i<user.actuators.length; i++){
          let actuator_name = user.actuators[i];
          api_fetch(`/api/actuator/${actuator_name}?do-not-query-state`).then(response => {
            // this.setState({actuators: {actuator: } })
            // console.log("got actuator response", actuator, response);
            if (!response.ok){
              throw new Error(`Response error ${response}` );
            }
            return response.json();
          }).then(actuator_data => {
            if (actuator_data.requires_cams && actuator_data.requires_cams.length == 1){
              
              if (actuator_data.requires_cams[0].length == 0)
              {
                actuator_data.requires_cams = [];
              }
            }
            actuator_data.requires_cams = actuator_data.requires_cams.map(camName => camName.split(".").slice(0,-1).join(".") );
            this.setState({
              actuators: [...this.state.actuators, actuator_data]
            });
          }).catch(error =>{
            console.error(`Fetching actuator ${actuator_name} state`, error);
          });
        }
      }

      if (user.intercoms){
        for (let i=0; i<user.intercoms.length; i++){
          let intercom_name = user.intercoms[i];
          api_fetch(`/api/intercom/${intercom_name}`).then(response => {
            // this.setState({intercoms: {intercom: } })
            // console.log("got intercom response", intercom, response);
            if (!response.ok){
              throw new Error(`Response error ${response}` );
            }
            return response.json();
          }).then(intercom_data => {
              this.setState(prevState => {
                let newState = prevState;
                newState.intercoms[intercom_data.attach_to_cam.split(".").slice(0,-1).join(".")] = intercom_data;
                newState
                }
            )
          }).catch(error =>{
            console.error(`Fetching intercom ${intercom_name} state`, error);
          });
        }

      }
      if (user.activity_areas){ 
        let areas = [];
        for (let i=0; i<user.activity_areas.length; i++){
          if (user.activity_areas[i].length == 0){
            continue
          }
          areas.push(user.activity_areas[i])
        }
        // fetch for areas cams
        let areas_csv = areas.join(",");
        api_fetch(window.location.origin + `/vmserver/definitions/?areas=${areas_csv}`).then(response => {
      
          if (!response.ok){
            throw new Error(`Response error ${response}` );
          }
          return response.json();
        }).then(area_cams => {
            this.setState({area_cams: area_cams["areas"]})

        }).catch(error =>{
          console.error(`Fetching area_cams`, error);
        });        

        this.setState({user_activity_areas: areas})

      }

      // POC test comm. with motail
      api_fetch(`/motail/ping`).then(response => {
        // this.setState({intercoms: {intercom: } })
        // console.log("got intercom response", intercom, response);
        if (!response.ok){
          throw new Error(`Response error ${response}` );
        }
        return response.json();
      }).then((data) => {
        console.log("motail OK", data);
      }).catch(error =>{
        console.error(`Reaching motail service`, error);
      });
      
    })
    .catch(error => {
      console.error(error);
      this.setState({loading_state: "error", loading_state_error: error.message});
    });
  }

  render() {

    if (this.state.loading_state != "ok"){
      let loading_state = this.state.loading_state;
      let loading_state_error = this.state.loading_state_error;

      return(
        <div className="system_info">
          <div>STATUS</div>
          <div>server: {this.state.server.name} </div>
          <div>version: {version_info.version} </div>
          <div>version date: {version_info.date} </div>
          <div>{loading_state} </div>
          <div>{loading_state_error} </div>
        </div>
      )

    }

    const panes = this.state.panes;
    const showCamSwitches = this.state.camSwitchBoardIsVisible;
    const showActuatorMenu = this.state.actuatorMenuIsVisible;
    
    // panes
    let showhighDefVideoSwitch = false;
    if (this.state.user.permissions.includes("high-def-video")){
      showhighDefVideoSwitch = true;
    }
    const panesElements = panes.map((item) => {
      
      return <Pane
        key={item.camName}
        camId={item.camName}
        hightlight={item.hightlight}
        showhighDefVideoSwitch={showhighDefVideoSwitch}
        // actuators={[this.state.actuators['test']]}
        intercom={this.state.intercoms[item.camName]}
        panesCount={panes.length}
        setVideoStatus={this.setVideoStatus}
      />
     
    });
    
     let serverInfo = (
      <div className="system_info">
        <div>server: {this.state.server.name} </div>
        <div>version: {version_info.version} </div>
        <div>version date: {version_info.date} </div>
      </div> 
     );
     
     if (panesElements.length > 0){
        serverInfo = undefined;
     }

    //  cam swtch enabler button
    let camSwitchEnablerButton = null;
    if (false && showCamSwitches === false){
      camSwitchEnablerButton = (
        <button
          className="btn-mini-alpha"
          onClick={this.showCamSwitchBoard} >&#x21f1;
        </button>
      );

    }
    
    // debug container
    let debugContainer = null;
    if (this.state.debugging === true){
      debugContainer = <pre id="debug-div" > debug</pre>
    }

    // shut down container
    let shutDownContainer = null;
    if (this.state.will_shut_down === true){
      shutDownContainer = (
        <div className="will-shut-down-dialog">
          <div className="will-shut-down-dialog-text">Will shut down</div>
          </div>
      );

    }

    // cam switch container
    const camSwitchBoardContainer = (
      <div ref={this.camSwitchBoardContainer} className="flex-column overflow">
        <CamSwitchBoard
          cameras={this.state.cameras}
          showCamSwitches={showCamSwitches}
          getCamPane={this.getCamPane}
          addCam={this.addCam}
          removeCam={this.removeCam}
          removeAllCams={this.removeAllCams}
          setHightLightPane={this.setHightLightPane}sg 

        />
        <div className="flex-grow-2" />
      </div>
    );

    // actuators menu
    let actuatorsMenu = null;
    if (showActuatorMenu){
      actuatorsMenu = (
        // <div className="actuator-menu-outter-container">
          <div className="actuators-menu-container">
            <Actuators
              actuators={this.state.actuators}
              user_actuators_names={this.state.user_actuators_names}
              setActiveActuator={this.setActiveActuator}
              
            />
          </div>
        // </div>
      )
    }

    // actuator pad
    let actuatorPad = null;
    if (this.state.activeActuator){
      
      actuatorPad = (
        
          <div className="actuator-pad-container">
            <ActuatorPad
              key={this.state.activeActuator.name}
              actuator={this.state.activeActuator}
              closeActuatorPad={this.closeActuatorPad}
              videoStatus={this.state.video_status}
              
            />
          </div>
        
      )

    }
    // activity menu
    let activitiesWidget = null;
    if (this.state.activity_widget_area !== undefined){
      activitiesWidget = (
        // <div className="actuator-menu-outter-container">
          
            <ActivitiesWidget key={this.state.activity_widget_area} area={this.state.activity_widget_area}/>
        // </div>
      )
    }


    let panesClass = "grid-" + panes.length;
    // if (panes.length == 1) {
    //   panesClass += " flex";

    // }

    return(
        <div className="root-sub-container">
            {shutDownContainer}
            {debugContainer}
            <div className="flex-column flex flex-grow-1" >
              <div onClick={this.onPanesClick} className={panesClass} >
                
                {panesElements}
                {serverInfo}
              </div>
              
            </div>
            <div className="switch-board-container half-height flex-column ">
              <div className="flex-grow-2 flex-fill " />
              {camSwitchBoardContainer}
              <div className="flex-grow-2 flex-fill  " />
              <div className="flex-row ">
                    <div className="flex-grow-2" />
                    {camSwitchEnablerButton}
              </div>
            </div>
            {activitiesWidget}
            {actuatorsMenu}
            {actuatorPad}
        </div>
    );
  }
}


function addCamToPanes(panes, camName, pinned){
  // exclude un pinned cams
  let tmpPanes = panes.filter((value) => value.pinned);
  if (tmpPanes.length == MAX_PANES && pinned === false){
    console.warn("can max panes reached")
    return;
  }
  if (tmpPanes.length == MAX_PANES){
    tmpPanes = panes.slice(1);
  }
  
  const insertAt = tmpPanes.length;

  if (insertAt == -1){
    console.error("could not add to pane", panes);
    return;
  }
  // insert cam into panes at insertAt
  // const panes = this.state.panes;
  return tmpPanes
    .slice(0,insertAt)
    .concat([{camName, pinned}])
    .concat(tmpPanes.slice(insertAt));
}

function removeCamFromPanes(panes, camName, force){
  return panes.filter((value) => {
      if (value.camName != camName){
        return true;
      }
      if (value.pinned == true && force == false){
        return true;
      }
      return false;
    });
}

export default App;
